import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { CacheSwitch } from 'react-router-cache-route'
import { UdSidebar, UdMenu, UdMain, routeUtils, uaaApp } from '@ud/admin-framework'
import { appStore } from '../../stores/appStore'
import NotFound from '../../components/NotFound'
import './UaaContainer.less'

const UaaContainer: React.FC = () => {
  appStore.showCenterHeader = appStore.showCenterSidebar = true
  console.log(appStore.uaaMenus, 'mueee')
  console.log(appStore,'---1')
  console.log(uaaApp, 'btn---')
  return (
    <div className="uaa-container">
      <UdSidebar title={appStore.uaaAppName}>
        <UdMenu menus={appStore.uaaMenus} />
      </UdSidebar>
      <UdMain>
        <CacheSwitch>
          {appStore.uaaRouteNodes}
          <Route path="/uaa/404" render={() => <NotFound className="uaa-not-found" />} exact={true} />
          <Route path="/uaa" exact={true} render={() => {
            let path = routeUtils.getFirstPathFromMenu(appStore.uaaMenus)!
            return <Redirect to={path} />
          }} />
          <Route path="*" render={() => <Redirect to="/uaa/404" />} />
        </CacheSwitch>
      </UdMain>
    </div>
  )
}

export default UaaContainer
